var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, InputAdornment, TextField, Tooltip, } from "@mui/material";
export const CopyField = (_a) => {
    var { value, inputComponent, htmlInputProps, shrinkLabel } = _a, rest = __rest(_a, ["value", "inputComponent", "htmlInputProps", "shrinkLabel"]);
    const [tooltip, setTooltip] = useState("Copy");
    const handleCopy = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(value == null ? "" : String(value));
            setTooltip("Copied!");
        }
        catch (_a) {
            setTooltip("Copy Error!");
        }
    });
    return (_jsx(TextField, Object.assign({}, rest, { type: "text", value: value !== null && value !== void 0 ? value : "", slotProps: {
            htmlInput: htmlInputProps,
            inputLabel: { shrink: shrinkLabel },
            input: {
                inputComponent,
                readOnly: true,
                endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(Tooltip, { title: tooltip, children: _jsx(IconButton, { onClick: handleCopy, children: _jsx(ContentCopyIcon, {}) }) }) })),
            }
        } })));
};
export const DefaultCopyField = CopyField;
